<template>
    <div class="tw:relative tw:group">
        <label
            class="tw:flex tw:flex-col tw:items-center tw:justify-center tw:w-full tw:h-32 tw:border-2 tw:border-dashed tw:border-slate-300 tw:rounded-2xl tw:cursor-pointer tw:bg-slate-50 tw:hover:bg-slate-100 tw:transition-all">
            <div class="tw:flex tw:flex-col tw:items-center tw:justify-center tw:pt-5 tw:pb-6 tw:px-4 tw:text-center">
                <i :class="icon"
                    class="tw:text-2xl tw:text-slate-400 tw:mb-2 tw:group-hover:text-brand-primary tw:transition-colors"></i>
                <p class="tw:text-xs tw:text-slate-600 tw:font-medium tw:mb-1">
                    <span class="tw:font-semibold tw:text-slate-800">{{ label }}</span> o arrastra aquí
                </p>
                <p class="tw:text-[10px] tw:text-slate-400" v-if="fileName">{{ fileName }}</p>
                <p class="tw:text-[10px] tw:text-slate-400" v-else>{{ acceptText }}</p>
            </div>
            <input type="file" class="tw:hidden" :accept="accept" :required="required" @change="handleFileChange" />
        </label>
    </div>
</template>

<script>
export default {
    name: 'BaseFile',
    props: {
        label: { type: String, default: 'Selecciona un archivo' },
        accept: { type: String, default: 'image/jpeg, image/png' },
        acceptText: { type: String, default: 'PNG, JPG hasta 10MB' },
        icon: { type: String, default: 'fas fa-cloud-upload-alt' },
        required: { type: Boolean, default: false }
    },
    data() {
        return {
            fileName: ''
        }
    },
    methods: {
        handleFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.fileName = file.name;
            } else {
                this.fileName = '';
            }
            // Emitimos el evento change nativo o el archivo para que el padre lo capture
            this.$emit('change', event);
        }
    }
}
</script>